import React, { createContext, useState } from 'react';

const SidebarContext = createContext();
export default SidebarContext

export const SidebarState = ({ children }) => {

  const [navCollapsed, setNavCollapsed] = useState(false);

  const toggleCollapsedSideNav = () => {
    setNavCollapsed(!navCollapsed)
  }

  return (
    <SidebarContext.Provider
      value={{
        navCollapsed,
        toggleCollapsedSideNav,
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}


